import React, { createContext, useState, useEffect, useRef } from "react";
import axios from "axios";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") ? true : false
  );

  const checkAuth = () => {
    axios
      .get("/me")
      .then((response) => {
        setUser(response.data);
        setLoggedIn(true);
      })
      .catch(() => {
        logout();
      });
  };

  const authRef = useRef({ checkAuth, loggedIn });

  useEffect(() => {
    const { checkAuth, loggedIn } = authRef.current;
    if (loggedIn) {
      checkAuth();
    }
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("content");
    setLoggedIn(false);
    setUser(null);
    delete axios.defaults.headers.common["Authorization"];
  };

  const register = (regData) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/register", regData)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);
          axios.defaults.headers.common["Authorization"] = token;
          checkAuth();
          resolve();
        })
        .catch((err) => {
          reject(err.response.data);
        });
    });
  };

  const login = (logData) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/login", logData)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);
          axios.defaults.headers.common["Authorization"] = token;
          checkAuth();
          resolve();
        })
        .catch((err) => {
          reject(err.response.data);
        });
    });
  };

  return (
    <UserContext.Provider
      value={{
        loggedIn,
        user,
        checkAuth,
        register,
        login,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
